import { ActiveTab } from "../types";

export const SET_ACTIVE_TAB_STATE = "SET_ACTIVE_TAB_STATE";

export function setActiveTabState(activeTab:ActiveTab) {
    return {
        type: SET_ACTIVE_TAB_STATE,
        payload: activeTab
    };
}